import './style.sass';

import parse from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallText from '../../../common-components/common-small-text';

let list = [
    `
      <p class="linkbuilder-tasks__list-item">Мы создаем автоматизированный сервис, не имеющий аналогов на мировом рынке. Это новый способ взаимодействия с поисковыми системами.  Единственное, что требуется от пользователя — это ввести ключевые слова. Сервис с помощью алгоритма искусственного интеллекта находит в Google сайты-доноры, подходящие для эффективного внедрения ссылок.</p>
      <p class="linkbuilder-tasks__bold">Точность подбора составляет более 90%.</p>
     `,
];

const Process = () => {
    return (
        <div className="linkbuilder-tasks__content-wrap">
            <FullWrapper smallPaddings={true} isMargin={false}>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <div className="linkbuilder-tasks__content">
                        <ScrollAnimation
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className="linkbuilder-tasks__content"
                        >
                            <img
                                className="linkbuilder-tasks__img"
                                src="/images/pic/linkbuilder/linkbuilder-screen.png"
                                alt=""
                                loading="lazy"
                            />
                            <div>
                                <div className="linkbuilder-tasks__title-img">
                                    <img
                                        className="linkbuilder-tasks__img"
                                        src="/images/svg/linkbuilder/logo-linkb-ai.svg"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>

                                {list.map(item => (
                                    <CommonSmallText key={item}>{parse(item)}</CommonSmallText>
                                ))}
                            </div>
                        </ScrollAnimation>
                    </div>
                </ScrollAnimation>
            </FullWrapper>
        </div>
    );
};

export default Process;
